import { memo } from "react";
import { useLocation } from "react-router-dom";
import MenuItem from "./MenuItem";

function Navigator({ menus, onMenuClick, disabled }) {
  const { pathname } = useLocation();

  const isActive = ({ menuActiveRegex }) =>
    !!menuActiveRegex?.some((regex) => regex.test(pathname));

  return (
    <>
      {menus.map((menu) => (
        <MenuItem
          key={menu.key}
          loading={menu.loading}
          icon={menu.icon}
          label={menu.label}
          active={isActive(menu)}
          onClick={(evt) => onMenuClick(menu.key, evt)}
          disabled={disabled}
        />
      ))}
    </>
  );
}

export default memo(Navigator);
